import { Dialog } from "primereact/dialog";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import {
    closeInstantQuotationDeleteModal, deleteInstantQuotationThunk,
    instantQuotationSelector
} from "../../features/instantQuotationSlice";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { QuotationRequestState } from "../../types/quotations/QuotationRequestState";
import { successToast, warningToast } from "@idwal/idwal-react-components";
import { getQuotationsThunk } from "../../features/quotationsSlice";
import { QuotationStatus } from "../../constants/QuotationConstants";
import { userSliceSelector } from "../../features/userSlice";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import { QUOTATIONS_ROUTE } from "../../config/router";

export const DeleteQuotation = () => {
    const {
        deleteModalData,
        deleteModalOpen,
        deleteQuotationRequestState
    } = useAppSelector(instantQuotationSelector);
    const { user } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);
    const {
        SelectedGroupName,
        OrganisationsInfo
    } = useAppSelector(userSliceSelector);

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { t } = useTranslation("locale");

    if (deleteQuotationRequestState == QuotationRequestState.Failed) {
        warningToast(t("quotations.deleteFailMessage"));
    }

    if (deleteQuotationRequestState == QuotationRequestState.CompleteDelete) {
        dispatch(closeInstantQuotationDeleteModal());
        successToast(t("quotations.deleteMessage"));
        dispatch(getQuotationsThunk({
            orgIds: [
                SelectedGroupName !== "" ? SelectedGroupName : OrganisationsInfo[0].id.toString()],
            user: user,
            statuses: [QuotationStatus.LEAD, QuotationStatus.OFFER]
        }));
        navigate(`/${QUOTATIONS_ROUTE}`);
    }

    const deleteQuoteButton = () => {
        if (deleteQuotationRequestState == QuotationRequestState.Idle) {
            return <Button
                style={{ width: "180px", height: "52px" }}
                data-cy={"delete-instant-quotation"}
                label={t("quotations.deleteButton")}
                className="p-button-danger"
                onClick={() => {
                    dispatch(deleteInstantQuotationThunk({ id: deleteModalData.id }));
                }}
            />;
        }

        return <Button
            style={{ width: "180px", height: "52px" }}
            disabled={true}
            icon={"pi pi-spin pi-spinner"}
            className={"p-button-danger"}
        />;
    };

    const cancelButton = () => {
        return <Button
            onClick={() => dispatch(closeInstantQuotationDeleteModal())}
            className="p-button p-component p-button-text"
        >
                    <span
                        data-cy="close-delete-quotation-modal"
                        className="p-button-label p-c w-9rem"
                    >
                        {t("instantQuotation.cancel")}
                    </span>
        </Button>;
    };

    return <Dialog
        blockScroll
        header={t("quotations.deleteTitle")}
        visible={deleteModalOpen}
        style={{ width: "42.5rem" }}
        onHide={() => {
            dispatch(closeInstantQuotationDeleteModal());
        }}
        draggable={false}
    >
        <div>Quotation {deleteModalData.quotationNumber} for
            a {deleteModalData.inspectionType} on {deleteModalData.vesselName}, will be deleted from the platform and
            will
            not be retrievable.
        </div>
        <div className="flex align-items-center justify-content-center mt-4">
            {cancelButton()}
            {deleteQuoteButton()}
        </div>
    </Dialog>;

};
